import React from 'react';
import DailyFeeRegister from './Daily_Fee_Register';
import '../../../CommonCSS/SocietyCSS.css'

const DailyFeeRegApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Daily Fee Register</h5>
          </div>
        </div>
        <DailyFeeRegister />
      </div>
    </div >
  );
};

export default DailyFeeRegApp;
